<div class="bg-white flex flex-col h-full">
  <div class="flex-1 overflow-y-auto">
    <div class="pb-[30px]">
      <ng-content select=".v4-base-selector-body_filters"></ng-content>
    </div>

    <div class="body">
      <div class="v4-option-list" *ngIf="listOfOption?.length; else empty">
        <div class="v4-option-item" (click)="onSelectOption(opt)" *ngFor="let opt of listOfOption">
          <div class="v4-option" [class.selected]="setOfSelectedOpts.has(opt.value)">{{ opt.label }}</div>
        </div>
      </div>

      <ng-container *ngIf="showExtra && listOfExtraOption?.length">
        <div class="flex flex-row items-center cursor-pointer mb-[12px]" (click)="unfoldExtra = !unfoldExtra">
          <span class="text-xs text-c-l2">
            {{
              (unfoldExtra ? "component.search.collapse_deleted_houses" : "component.search.show_deleted_houses")
                | translate
            }}
            <!-- 显示已删除的房间 -->
          </span>
          <img class="w-[9px] ml-1" [class.rotate-180]="unfoldExtra" src="/assets/v4/icon-arrow-down.svg" alt="" />
        </div>
        <div class="v4-option-list" *ngIf="unfoldExtra">
          <div class="v4-option-item" (click)="onSelectOption(opt)" *ngFor="let opt of listOfExtraOption">
            <div class="v4-option" [class.selected]="setOfSelectedOpts.has(opt.value)">{{ opt.label }}</div>
          </div>
        </div>
      </ng-container>

      <ng-template #empty>
        <div class="v4-layout-empty my-[100px]">
          <img class="v4-layout-empty-img" src="/assets/icon/no_data.png" />
          <div class="v4-layout-empty-content">
            <div class="v4-layout-empty-title">
              {{ "word.no_data" | translate }}
              <!-- No Data -->
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>

  <div class="footer flex flex-row items-center justify-between pt-[30px]" *ngIf="showFooter">
    <div *ngIf="mode === 'multi'">
      <a class="mr-3" nz-button nzType="link" (click)="onSelectAll()">
        {{ "word.select_all" | translate }}
        <!-- Select all -->
      </a>
      <a nz-button nzType="link" (click)="onClickReset()">
        {{ "word.reset" | translate }}
        <!-- Reset -->
      </a>
    </div>
    <div class="ml-auto">
      <button class="mr-3" nz-button nzSize="large" (click)="onClickCancel()">
        {{ "word.cancel" | translate }}
        <!-- Cancel -->
      </button>
      <button nz-button nzSize="large" nzType="primary" (click)="onClickConfirm()">
        {{ "word.confirm" | translate }}
        <!-- OK -->
      </button>
    </div>
  </div>
</div>
